import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiGet } from '../../../../api/queries/apiGet';
import { TEMPLATES_BASE_URL } from '../consts';
import { policyTemplatesQueryKeys } from '../queryKeys';
import { PolicyTemplateRisk } from '../../Templates/types/risk';

const END_POINT = '/risks';

type PolicyTemplateRisksDto = PolicyTemplateRisk;

const transformPolicyTemplateRisksDtoToPolicyTemplateRisk = (dto: PolicyTemplateRisksDto): PolicyTemplateRisk => {
    return {
        id: dto.id,
        name: dto.name
    };
};

const fetchRisks = async (): Promise<PolicyTemplateRisksDto[]> => {
    const data = await apiGet<PolicyTemplateRisksDto[]>(`${TEMPLATES_BASE_URL}${END_POINT}`);
    return data;
};

export const useGetPolicyTemplateRisks = (): UseQueryResult<PolicyTemplateRisk[]> => {
    return useQuery({
        queryKey: policyTemplatesQueryKeys.risks(),
        queryFn: fetchRisks,
        select: (data) => data.map(transformPolicyTemplateRisksDtoToPolicyTemplateRisk)
    });
};
